module.exports = __webpack_public_path__ + "img/bb_g3_antenna-05.40ccd023.svg";